import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  static drawerFrameId = 'review_drawer_content'

  static targets = [
    'backdrop',
    'liveRegion',
    'panel',
    'primaryField',
  ]

  static values = { open: Boolean }

  connect() {
    useClickOutside(this, { element: this.panelTarget })
    this.closing = false
    this.boundClose = this.close.bind(this)

    this.keydownHandler = (event) => {
      if (!this.openValue) return
      if (event.key === 'Escape') this.close()
    }

    this.frameLoadHandler = (event) => {
      if (event.target?.id !== this.constructor.drawerFrameId) return

      this.open()
      this.afterFrameLoad?.()
      this.announce('Review drawer opened')
    }

    document.addEventListener(
      'review-drawer:close',
      this.boundClose,
    )
    window.addEventListener('keydown', this.keydownHandler)
    window.addEventListener('turbo:frame-load', this.frameLoadHandler)
  }

  clickOutside() {
    if (this.openValue) this.close()
  }

  close() {
    if (!this.openValue || this.closing) return
    this.closing = true
    document.body.classList.remove('overflow-hidden')
    Promise.all([
      leave(this.panelTarget),
      leave(this.backdropTarget),
    ]).then(() => {
      this.openValue = false
      this.closing = false
      this.afterClose?.()
    })
    this.announce('Review drawer closed')
  }

  disconnect() {
    document.body.classList.remove('overflow-hidden')
    document.removeEventListener(
      'review-drawer:close',
      this.boundClose,
    )
    window.removeEventListener('keydown', this.keydownHandler)
    window.removeEventListener(
      'turbo:frame-load',
      this.frameLoadHandler,
    )
  }

  open() {
    if (this.openValue) return
    this.openValue = true
    document.body.classList.add('overflow-hidden')
    enter(this.panelTarget)
    enter(this.backdropTarget)
  }

  announce(message) {
    if (this.hasLiveRegionTarget) {
      this.liveRegionTarget.textContent = message
    }
  }
}
